import React from 'react';
import { ReactComponent as ApplicantDetailsIcon } from 'src/assets/icons/applicantDetails.svg';
import { ReactComponent as ApplicationIcon } from 'src/assets/icons/applications.svg';
import { ReactComponent as AttendanceIcon } from 'src/assets/icons/attendance.svg';
import { ReactComponent as BallIcon } from 'src/assets/icons/ball.svg';
import { ReactComponent as BookIcon } from 'src/assets/icons/book.svg';
import { ReactComponent as CalculatorIcon } from 'src/assets/icons/calculator.svg';
import { ReactComponent as ContentIcon } from 'src/assets/icons/content.svg';
import { ReactComponent as DownloadCentralIcon } from 'src/assets/icons/downloadCentral.svg';
import { ReactComponent as EligibilityCheckIcon } from 'src/assets/icons/eligibilityCheck.svg';
import { ReactComponent as ExistingProductsIcon } from 'src/assets/icons/existingProducts.svg';
import { ReactComponent as GlobeIcon } from 'src/assets/icons/globe.svg';
import { ReactComponent as InfoIcon } from 'src/assets/icons/info.svg';
import { ReactComponent as LearningIcon } from 'src/assets/icons/learning.svg';
import { ReactComponent as MarketingCollateralsIcon } from 'src/assets/icons/marketingCollaterals.svg';
import { ReactComponent as OffersIcon } from 'src/assets/icons/offers.svg';
import { ReactComponent as OngoingOpportunitiesIcon } from 'src/assets/icons/ongoingOpportunities.svg';
import { ReactComponent as PartnerPortalIcon } from 'src/assets/icons/partnerPortal.svg';
import { ReactComponent as PolicyDetailsIcon } from 'src/assets/icons/policyDetails.svg';
import { ReactComponent as RecommendedProductsIcon } from 'src/assets/icons/recommendedProducts.svg';
import { ReactComponent as RenewalsIcon } from 'src/assets/icons/renewals.svg';
import { ReactComponent as ReportsIcon } from 'src/assets/icons/reports.svg';
import { ReactComponent as ServicesIcon } from 'src/assets/icons/services.svg';
import { ReactComponent as SpActivityAnalyticsIcon } from 'src/assets/icons/spActivityAnalytics.svg';
import { ReactComponent as SpCampaignsIcon } from 'src/assets/icons/spCampaigns.svg';
import { ReactComponent as SpContentLibraryIcon } from 'src/assets/icons/spContentLibrary.svg';
import { ReactComponent as SpgBlocksIcon } from 'src/assets/icons/spgBlocks.svg';
import { ReactComponent as SpgClockIcon } from 'src/assets/icons/spgClock.svg';
import { ReactComponent as SpgDocsIcon } from 'src/assets/icons/spgDocs.svg';
import { ReactComponent as SpgFallbackIcon } from 'src/assets/icons/spgFallback.svg';
import { ReactComponent as SpgLeadsIcon } from 'src/assets/icons/spgLeads.svg';
import { ReactComponent as SpgListIcon } from 'src/assets/icons/spgList.svg';
import { ReactComponent as SpgPageIcon } from 'src/assets/icons/spgPage.svg';
import { ReactComponent as SpgSettingsIcon } from 'src/assets/icons/spgSettings.svg';
import { ReactComponent as SpgStarIcon } from 'src/assets/icons/spgStar.svg';
import { ReactComponent as SpProspectTrackerIcon } from 'src/assets/icons/spProspectTracker.svg';
import { ReactComponent as ToolIcon } from 'src/assets/icons/tool.svg';
import { SpgIconProps } from '../types';

function SpgIcon({ icon_uri }: SpgIconProps): JSX.Element {
  const getSpgIcon = (iconUri?: string) => {
    const iconMapping = {
      existing_products: <ExistingProductsIcon />,
      recommended_products: <RecommendedProductsIcon />,
      ongoing_opportunities: <OngoingOpportunitiesIcon />,
      offers: <OffersIcon />,
      service: <ServicesIcon />,
      calculator: <CalculatorIcon />,
      verified_customers: <SpgFallbackIcon />, // No matching icon, using fallback
      policy_details: <PolicyDetailsIcon />,
      eligibility_check: <EligibilityCheckIcon />,
      attendance: <AttendanceIcon />,
      marketing_collaterals: <MarketingCollateralsIcon />,
      applications: <ApplicationIcon />,
      content: <ContentIcon />,
      leads: <SpgLeadsIcon />,
      learning: <LearningIcon />,
      download_central: <DownloadCentralIcon />,
      renewals: <RenewalsIcon />,
      partner_portal: <PartnerPortalIcon />,
      applicants_details: <ApplicantDetailsIcon />,
      report: <ReportsIcon />,
      info: <InfoIcon />,
      globe: <GlobeIcon />,
      star: <SpgStarIcon />,
      clock: <SpgClockIcon />,
      settings: <SpgSettingsIcon />,
      blocks: <SpgBlocksIcon />,
      page: <SpgPageIcon />,
      list: <SpgListIcon />,
      book: <BookIcon />,
      tools: <ToolIcon />,
      ball: <BallIcon />,
      docs: <SpgDocsIcon />,
      ic_campaigns: <SpCampaignsIcon />,
      ic_content_library: <SpContentLibraryIcon />,
      ic_prospect_tracker: <SpProspectTrackerIcon />,
      ic_activity_analytics: <SpActivityAnalyticsIcon />,
    };

    return (
      iconMapping[iconUri as keyof typeof iconMapping] || <SpgFallbackIcon />
    );
  };

  // Return either the custom icon or fallback to CampaignIcon
  return ['SVG'].includes(icon_uri?.split('.')?.pop()?.toUpperCase() ?? '') ? (
    <img src={icon_uri} alt="" aria-hidden="true" /> // Explicitly marking as decorative image
  ) : (
    getSpgIcon(icon_uri)
  );
}

export default SpgIcon;
